(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-types"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const filterParam = 'filter.p.product_type';

    function parseJsonScript(element, fallback) {
      if (!element) return fallback;
      try {
        let value = JSON.parse(element.textContent || 'null');
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value);
          } catch (_) {
            // A JSON field may already be serialized as a string.
          }
        }
        return value ?? fallback;
      } catch (_) {
        return fallback;
      }
    }

    function initCollectionTypes(scope = document) {
      const roots = [];
      if (scope.matches?.('[data-collection-types]')) roots.push(scope);
      roots.push(...(scope.querySelectorAll?.('[data-collection-types]') || []));

      roots.forEach((root) => {
        if (root.dataset.initialized === 'true') return;
        root.dataset.initialized = 'true';

        const options = Array.from(root.querySelectorAll('[data-product-type-option]'))
          .map((node) => ({
            value: node.dataset.value || '',
            count: Number.parseInt(node.dataset.count || '0', 10),
            active: node.dataset.active === 'true'
          }))
          .filter((option) => option.value && (option.count > 0 || option.active));
        const available = new Map(options.map((option) => [option.value, option.value]));
        const buttons = Array.from(root.querySelectorAll('[data-collection-type-button]'));
        const currentUrl = new URL(window.location.href);
        const selectedTypes = currentUrl.searchParams.getAll(filterParam);

        let visibleCount = 0;
        buttons.forEach((button) => {
          const category = parseJsonScript(button.querySelector('[data-category-data]'), null);
          const manual = parseJsonScript(button.querySelector('[data-manual-types]'), '');
          const categoryTypes = Array.isArray(category?.product_types) ? category.product_types : [];
          const manualTypes = typeof manual === 'string' ? manual.split(/\r?\n/) : [];
          const configured = [...new Set([...categoryTypes, ...manualTypes].map((type) => String(type).trim()).filter(Boolean))];
          const matches = configured.map((type) => available.get(type)).filter(Boolean);

          if (!matches.length || !button.dataset.label) return;

          visibleCount += 1;
          button.hidden = false;
          button.setAttribute('aria-label', `Filter by ${button.dataset.label}`);

          const selectedSet = new Set(selectedTypes);
          const isExactGroupSelection = selectedSet.size === matches.length && matches.every((type) => selectedSet.has(type));
          if (isExactGroupSelection) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');

          button.addEventListener('click', (event) => {
            event.preventDefault();
            const nextUrl = new URL(window.location.href);
            nextUrl.searchParams.delete(filterParam);
            // A changed filter set should return to the first page, but retain sort, price, and other filters.
            nextUrl.searchParams.delete('page');

            if (!isExactGroupSelection) {
              matches.forEach((type) => nextUrl.searchParams.append(filterParam, type));
            }

            window.location.assign(`${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
          });
        });

        if (visibleCount === 0) root.hidden = true;
      });
    }

    initCollectionTypes();
    document.addEventListener('DOMContentLoaded', () => initCollectionTypes());
    document.addEventListener('shopify:section:load', (event) => initCollectionTypes(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collectons-filter-dropdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vehicle-fitment-filter')) {
    customElements.define(
      'vehicle-fitment-filter',
      class VehicleFitmentFilter extends HTMLElement {
        connectedCallback() {
          this.filterForm = this.querySelector('form');
          if (!this.filterForm) return;

          this.filterDropdowns = Array.from(this.querySelectorAll('[data-filter-dropdown]'));
          this.filterDropdowns.forEach((dropdown) => { dropdown.value = ''; });
          this.submitButton = this.querySelector('[type="submit"]');
          this.statusMessage = this.querySelector('[data-filter-status]');
          this.optionCache = new Map();
          this.eventController = new AbortController();
          const listenerOptions = { signal: this.eventController.signal };

          this.filterForm.addEventListener('submit', (event) => {
            event.preventDefault();
            if (this.loading || this.loadFailed) return;
            const parameters = this.buildSelectedFilterParameters();
            const query = parameters.toString();
            window.location.assign(query ? `${this.filterForm.action}?${query}` : this.filterForm.action);
          }, listenerOptions);

          this.querySelector('.vehicle-fitment__clear').addEventListener('click', (event) => {
            event.preventDefault();
            this.filterDropdowns.forEach((dropdown) => { dropdown.value = ''; });
            this.refreshFilterOptions();
          }, listenerOptions);

          this.filterDropdowns.forEach((dropdown, index) => {
            dropdown.addEventListener('change', () => {
              this.filterDropdowns.slice(index + 1).forEach((laterDropdown) => {
                laterDropdown.value = '';
              });
              this.refreshFilterOptions();
            }, listenerOptions);
          });

          this.refreshFilterOptions();
        }

        disconnectedCallback() {
          this.activeRequestController?.abort();
          this.eventController?.abort();
        }

        buildSelectedFilterParameters() {
          const parameters = new URLSearchParams();
          this.filterDropdowns.forEach((dropdown) => {
            if (!dropdown.disabled && dropdown.value !== '') {
              parameters.append(dropdown.dataset.filterParam, dropdown.value);
            }
          });
          return parameters;
        }

        async fetchFilterOptions(parameters, signal) {
          const url = new URL(this.filterForm.action, window.location.origin);
          url.search = parameters.toString();
          url.searchParams.set('section_id', this.dataset.sectionId);
          const cacheKey = url.toString();
          if (this.optionCache.has(cacheKey)) return this.optionCache.get(cacheKey);

          const response = await fetch(cacheKey, { signal });
          if (!response.ok) throw new Error(`Unable to refresh filters: ${response.status}`);

          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = document.getElementById(`VehicleFitmentFilter-${this.dataset.sectionId}`);
          if (!section) throw new Error('Unable to find the refreshed filter section');

          const options = Array.from(section.querySelectorAll('[data-filter-dropdown]')).map((dropdown) => ({
            available: dropdown.dataset.filterAvailable === 'true',
            values: Array.from(dropdown.options).map((option) => ({
              value: option.value,
              label: option.textContent,
              count: Number(option.dataset.count || 0),
            })),
          }));
          if (options.length !== this.filterDropdowns.length) {
            throw new Error('Incomplete filter response');
          }

          this.optionCache.set(cacheKey, options);
          return options;
        }

        updateControls() {
          const hasSelection = this.filterDropdowns.some((dropdown) => dropdown.value !== '');
          this.filterDropdowns.forEach((dropdown, index) => {
            const earlierStepsSelected = this.filterDropdowns.slice(0, index).every((earlierDropdown) =>
              earlierDropdown.value !== '' && earlierDropdown.dataset.filterAvailable === 'true'
            );
            dropdown.disabled = this.loading || !earlierStepsSelected ||
              dropdown.dataset.filterAvailable !== 'true' || dropdown.options.length < 2;
            dropdown.required = hasSelection && index === 0 && !dropdown.disabled;
          });
          this.submitButton.disabled = this.loading || this.loadFailed;
          this.setAttribute('aria-busy', String(this.loading));
        }

        async refreshFilterOptions() {
          this.activeRequestController?.abort();
          const controller = new AbortController();
          this.activeRequestController = controller;
          this.loading = true;
          this.loadFailed = false;
          this.statusMessage.hidden = true;
          this.updateControls();

          try {
            const allOptions = await this.fetchFilterOptions(new URLSearchParams(), controller.signal);
            const selections = this.filterDropdowns.map((dropdown) => dropdown.value);
            const refreshedOptions = [];

            for (let index = 0; index < this.filterDropdowns.length; index += 1) {
              const upstreamParameters = new URLSearchParams();
              const earlierStepsSelected = selections.slice(0, index).every((value) => value !== '');
              if (!earlierStepsSelected) {
                selections[index] = '';
                refreshedOptions.push({
                  available: allOptions[index].available,
                  options: allOptions[index].values.filter((option) => option.value === ''),
                });
                continue;
              }

              this.filterDropdowns.slice(0, index).forEach((earlierDropdown, earlierIndex) => {
                upstreamParameters.append(earlierDropdown.dataset.filterParam, selections[earlierIndex]);
              });

              const matchingOptions = upstreamParameters.size
                ? await this.fetchFilterOptions(upstreamParameters, controller.signal)
                : allOptions;
              const validValues = new Set(
                matchingOptions[index].values.filter((option) => option.count > 0).map((option) => option.value)
              );
              const options = allOptions[index].values.filter((option) =>
                option.value === '' || validValues.has(option.value)
              );
              if (!options.some((option) => option.value === selections[index])) {
                selections[index] = '';
              }
              refreshedOptions.push({ available: allOptions[index].available && matchingOptions[index].available, options });
            }

            if (this.activeRequestController !== controller || controller.signal.aborted) return;
            refreshedOptions.forEach(({ available, options }, index) => {
              const dropdown = this.filterDropdowns[index];
              dropdown.replaceChildren(...options.map(({ label, value }) =>
                new Option(label, value, false, value === selections[index])
              ));
              dropdown.name = dropdown.dataset.filterParam;
              dropdown.dataset.filterAvailable = String(available);
              dropdown.value = selections[index];
            });
          } catch (error) {
            if (this.activeRequestController !== controller || controller.signal.aborted) return;
            this.loadFailed = true;
            this.statusMessage.hidden = false;
          } finally {
            if (this.activeRequestController === controller) {
              this.loading = false;
              this.activeRequestController = null;
              this.updateControls();
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.mobileStickyReveal = window.matchMedia('(max-width: 989px)');
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      this.onMobileStickyRevealChange = () => {
        if (this.mobileStickyReveal.matches && !this.headerIsAlwaysSticky) {
          this.clearMobileStickyState();
        }
      };
      this.mobileStickyReveal.addEventListener('change', this.onMobileStickyRevealChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mobileStickyReveal.removeEventListener('change', this.onMobileStickyRevealChange);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.mobileStickyReveal.matches && !this.headerIsAlwaysSticky) {
        this.clearMobileStickyState();
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    clearMobileStickyState() {
      this.header.classList.remove(
        'scrolled-past-header',
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-image-card-grid"] && !Shopify.designMode) return;
  try {
    
  class ImageCardGridCarousel {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-mobile-carousel-track]');
      this.dots = Array.from(section.querySelectorAll('[data-mobile-carousel-dot]'));
      this.items = this.track ? Array.from(this.track.children) : [];
      this.mediaQuery = window.matchMedia(this.getMediaQuery());
      this.onScroll = this.onScroll.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);

      if (!this.track || this.dots.length === 0 || this.items.length === 0) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.scrollToItem(Number(dot.dataset.mobileCarouselIndex)));
      });

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.mediaQuery.addEventListener('change', this.onMediaChange);
      this.onMediaChange();
    }

    getMediaQuery() {
      if (this.section.classList.contains('image-card-grid--carousel-until-desktop')) {
        return '(max-width: 989px)';
      }

      return '(max-width: 749px)';
    }

    onMediaChange() {
      if (this.mediaQuery.matches) {
        this.updateActiveDot();
      } else {
        this.setActiveDot(0);
      }
    }

    onScroll() {
      window.requestAnimationFrame(() => this.updateActiveDot());
    }

    scrollToItem(index) {
      const item = this.items[index];
      if (!item) return;

      item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    updateActiveDot() {
      const trackCenter = this.track.scrollLeft + this.track.clientWidth / 2;
      let activeIndex = 0;
      let closestDistance = Infinity;

      this.items.forEach((item, index) => {
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;
        const distance = Math.abs(trackCenter - itemCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      this.setActiveDot(activeIndex);
    }

    setActiveDot(activeIndex) {
      this.dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }
  }

  document.querySelectorAll('.image-card-grid--mobile-carousel').forEach((section) => {
    new ImageCardGridCarousel(section);
  });

  } catch(e) { console.error(e); }
})();
})();
